import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './glitchstyles.css';
import slush from '../../Pictures/slush_logo_white.png';
import monk from '../../Pictures/monk_white.png';




export class Landerpage extends Component {

  render() {
    return (

    <section className="Content">
      <div className="content-holder content-holder-landerpage">

            <div className="glitch">
      					<div className="glitch_bg"></div>


                <div className="content-middle">


                <div className="block-slush">
                  <p>Report is produced by</p>
                  <a href="https://singapore.slush.org/">
                  <div className="logo-holder "><img alt="slush-logo" src={ slush } /></div>
                  </a>
                  <a href="https://www.monkshill.com">
                  <div className="logo-holder logo-holder-monk "><img alt="monkhill-logo" src={ monk } /></div>
                  </a>
                </div>
                <div className="block-title glitch_content">
                  <p className="header-name-row-1">THE STATE OF</p>
                  <p className="header-name-row-2">SOUTHEAST</p>
                  <p className="header-name-row-3">ASIAN TECH</p>
                  <h1 className="header-name-row-4">2018</h1>
                </div>


                <div className="block-button">
                  <Link to="/topics/introduction">
                    <div className="btn">
                      <p>EXPLORE THE DATA</p>
                    </div>
                  </Link>
                </div>


                <div className="block-button">
                  <a href="https://slush.us19.list-manage.com/subscribe/post?u=132a7ae12a590a50784bd9873&amp;id=79da32ad20">
                    <div className="btn">
                      <p>DOWNLOAD REPORT</p>
                    </div>
                  </a>
                </div>



                </div>


            </div>

        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/Landerpage.js